// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"63d466e2","667":"9f6b0664","977":"a1035851"}[chunkId] + ".chunk.js";
};